export { default } from './LazyCookiesPolicy';
